import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import useProjectStore from '../stores/projectStore';

/**
 * Lädt die Projekt-Liste beim Mount und invalidiert
 * alle projekt-abhängigen Queries beim Projekt-Wechsel.
 */
export default function useProjectSync() {
  const fetchProjects = useProjectStore((s) => s.fetchProjects);
  const loaded = useProjectStore((s) => s.loaded);
  const currentProjectId = useProjectStore((s) => s.currentProjectId);
  const qc = useQueryClient();
  const lastProjectRef = useRef(currentProjectId);

  useEffect(() => {
    if (!loaded) {
      fetchProjects();
    }
  }, [loaded, fetchProjects]);

  useEffect(() => {
    if (lastProjectRef.current !== currentProjectId && lastProjectRef.current !== null) {
      // Alle Queries außer projects/user neu laden — die hängen am Projekt-Scope
      qc.invalidateQueries({
        predicate: (q) => {
          const key = q.queryKey?.[0];
          return key !== 'projects' && key !== 'user' && key !== 'settings';
        },
      });
    }
    lastProjectRef.current = currentProjectId;
  }, [currentProjectId, qc]);
}
